export const spacing = {
  zero: '0', // 0
  zero_1: '0.25rem', // 4px
  zero_2: '0.5rem', //8px
  zero_3: '0.75rem', //12px
  one: '1rem', //16px
  one_1: '1.25rem', //20px
  one_2: '1.5rem', //24px
  one_3: '1.75rem', //28px
  two: '2rem', //32px
  two_1: '2.25rem', //32px
  two_2: '2.5rem', //40px
  three: '3rem', // 48px
  three_2: '3.5rem', // 56px
  four: '4rem', // 64px
  four_2: '4.5rem', // 72px
  five: '5rem', //80px
  six: '6rem', //96px
  six_2: '6.5rem', //104px
  six_3: '6.75rem', //108px
  eight: '8rem', //128px
};
